import { render, staticRenderFns } from "./googleLogin.vue?vue&type=template&id=52e9e803"
import script from "./googleLogin.vue?vue&type=script&lang=js"
export * from "./googleLogin.vue?vue&type=script&lang=js"
import style0 from "./googleLogin.vue?vue&type=style&index=0&id=52e9e803&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports